
import { Component, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalLoaderService } from '@loader';
import { States, StateService } from '@state';


@Component({
    selector: 'cookie-info-outside',
    templateUrl: './cookie.info.outside.template.html',
    standalone: false
})
export class CookieInfoOutsideComponent {
    constructor(private globalLoaderService: GlobalLoaderService, private stateService: StateService, private router: Router){}

    public popupVisible: true;

    public ngAfterViewInit(){
        this.stateService.values([States.currentOutlet, States.isLoggedIn]).subscribe((values) => {
            if(values.isLoggedIn){
                this.router.navigateByUrl('/CookieNotice')
                return true;
            }
            if(values.currentOutlet === 'internalreleasenotes'){
                this.globalLoaderService.hide();
            }
        }).falsy();
    }
}